module.exports = __webpack_public_path__ + "img/Ningxia Hui-power.fc7dc101.png";